import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';
import FormLocalStorage from '@/constants/FormLocalStorage';
import SitemapUrl from './interfaces/SitemapUrl';

export const useFormStore = defineStore('form', {
  state: () => ({
    baseSitemapUrls: useStorage<SitemapUrl[]>(FormLocalStorage, []),
  }),

  actions: {
    addBaseSitemapUrl(url: URL) {
      const currentTime = new Date();
      this.baseSitemapUrls.push({ url, lastUpdated: currentTime });
    },
    clearBaseSitemapUrls() {
      this.baseSitemapUrls = [];
    },
  },
});
